export function videoModal() {
	let modals = document.querySelectorAll('.modal-video');

	if(modals)
	{
		let tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		modals.forEach(modal =>
		{
			// Creates iframe and replace it with current div
			let player;
			let id = modal.id.substring(6);

			function onYouTubeIframeAPIReady() {
				player = new YT.Player('iframe-' + id, {
					videoId: id,
					events: {
						'onReady': onPlayerReady,
						'onStateChange': onPlayerStateChange
					}
				});
			}
			setTimeout(function(){
				onYouTubeIframeAPIReady();
			}, 500);

			function onPlayerReady(event) {
				let startBtn = document.getElementById('start-' + id);

				startBtn.addEventListener('click', function (event) {
					player.playVideo();
				}, false);
			}

			function onPlayerStateChange(event) {
				let root = document.getElementById('modal-content-' + id);
				document.addEventListener('click', function(event) {
					let inside = root.contains(event.target);
					if (!inside) {
						player.pauseVideo();
					}
				});
			}
		});
	}
}



